import styled from 'styled-components';
import { Alert } from '@interstate/components/Alert';
import { Action } from '@interstate/components/Action';

export const StyledFailureAlert = styled(Alert)`
    &&& {
        padding: 12px;
    }
`;

export const StyledAlertContent = styled.div`
    && {
        margin-left: 12px;
    }
`;

export const StyledRetryAction = styled(Action)`
    && {
        padding: 0;
        border: 0;
        display: inline;
        font-weight: 600;
    }
`;
